import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import app from "../firebase.js"; // ✅ ajout du .js pour compatibilité ES Modules

const ProtectedRoute = ({ children }) => {
  const auth = getAuth(app);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, [auth]);

  // Pendant la vérification de l'état de connexion
  if (loading) {
    return (
      <div style={styles.loading}>
        <h3>Chargement...</h3>
      </div>
    );
  }

  // Si l'utilisateur n'est pas connecté → redirection vers la page de connexion
  if (!user) {
    return <Navigate to="/connexion" replace />; // ✅ correction ici
  }

  // Sinon, on affiche le contenu protégé
  return children;
};

const styles = {
  loading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "80vh",
    color: "#007bff",
    fontFamily: "Arial, sans-serif",
  },
};

export default ProtectedRoute;